import script from "./WebVideoStream.vue?vue&type=script&setup=true&lang=js"
export * from "./WebVideoStream.vue?vue&type=script&setup=true&lang=js"

import "./WebVideoStream.vue?vue&type=style&index=0&id=10d32868&scoped=true&lang=scss"
import "./WebVideoStream.vue?vue&type=style&index=1&id=10d32868&lang=scss"
import "./WebVideoStream.vue?vue&type=style&index=2&id=10d32868&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10d32868"]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLayout});
